import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "bg-white p-3 m-2 me-3 ms-1",
  style: {"width":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Filtruj po algorytmach:")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0 p-0 mb-2" }, null, -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-switch m-0 mx-1" }
const _hoisted_6 = ["checked", "onChange", "id"]
const _hoisted_7 = ["for"]

import { computed, ref, watch } from "vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'TheFiltry',
  setup(__props) {

const store = useStore();
const algorithms = computed<string[]>(() => {
  const miners = store.getters["miners/getMiners"];
  const filters = Array.from(
    new Set(miners.map((e: { algorithm: string }) => e.algorithm))
  );
  store.commit("miners/setAlgorithmsFilter", filters);
  return filters;
});

const algorithmsFilter = computed<string[]>({
  set: (value: string[]) => {
    store.commit("miners/setAlgorithmsFilter", value);
  },
  get: () => store.getters["miners/getAlgorithmsFilter"],
});

// Use a Set to keep track of selected filters
const selectedFilters = ref<Set<string>>(new Set(algorithmsFilter.value));

// Watch for changes in the algorithmsFilter and update selectedFilters accordingly
watch(algorithmsFilter, (newValue) => {
  selectedFilters.value = new Set(newValue);
});

// Function to update checked filters array
const updateCheckedFilters = (coin: string) => {
  if (selectedFilters.value.has(coin)) {
    selectedFilters.value.delete(coin);
  } else {
    selectedFilters.value.add(coin);
  }
  algorithmsFilter.value = Array.from(selectedFilters.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(algorithms.value, (coin, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col",
          key: index
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", {
              checked: algorithmsFilter.value.includes(coin),
              onChange: ($event: any) => (updateCheckedFilters(coin)),
              class: "form-check-input",
              type: "checkbox",
              id: coin + index
            }, null, 40, _hoisted_6),
            _createElementVNode("label", {
              class: "form-check-label m-0 p-0 ms-3",
              for: coin + index
            }, _toDisplayString(coin), 9, _hoisted_7)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})